<div [ngClass]="{ 'layout-wrapper': true, 'layout-compact': layoutCompact }">
  <div [ngClass]="{ 'layout-container': false,
                  'menu-layout-static': (layoutMode=='static' || layoutMode=='horizontal'),
                  'menu-layout-overlay': (layoutMode=='overlay'),
                  'menu-layout-horizontal': (layoutMode=='horizontal') }">
    <div class="topbar clearfix header-background">
      <div class="header-div">
        <div 
            [ngStyle]="{'cursor': getCursor()}" 
            (click)="openRootPage()" 
            title="NIST Public Data Repository"
            class="header__logo-link" 
            style="display:inline-block;"
            rel="home">
            <!-- Logo -->
            <div class="logo-container">
                <div class="image-container">
                    <img src="assets/images/f_nist-logo-brand-white_nist-logo-brand-white.png" alt="Your Image" class="scaled-image" />
                </div>
            </div>

            <div style="display:inline-block;">
                <div class="logo-text">PUBLIC </div>
                <div class="logo-text">DATA REPOSITORY</div>
            </div>
        </div>

        <div style="display:inline-block; height: 29px;vertical-align: bottom;">
            <div *ngIf="appVersion" class="badge" id="appVersion">
                {{appVersion}}
            </div>

            <span 
                *ngIf="status" 
                class="badge" 
                id="appStatus" 
                style="background-color:rgb(0, 114, 114);">
                {{ status }}
            </span>
        </div>

        <div class="header-links" style="float: right; vertical-align: bottom;">
          <a href="/pdr/about" target="_blank"><b>About</b></a> |
          <a href="{{contactLink}}" target="_blank"><b>Help</b></a> |
          <a href="{{searchLink}}" target="_blank"><b>Search</b></a> |
          <!-- Datacart (Download Manager) always disabled if edit is enabled -->
          <a href="{{globalCartUrl}}" target="_blank" [ngStyle]="{'color':getMenuColor('Cart')}"
            [ngClass]="{'disabled':editEnabled,'enabled':!editEnabled}"><b>Cart</b><i
              class="faa faa-shopping-cart faa-1x" [ngStyle]="{'color':getMenuColor('Cart')}"></i><span
              class="w3-badge badge-notify">&nbsp;{{cartLength}}&nbsp;</span></a>
          <span *ngIf="editEnabled && editstatsvc.userID">
            | <i class="faa faa-user-circle faa-1x icon-white" style="color: white; cursor: pointer;"
              data-toggle="tooltip" title="{{editstatsvc.userID}}" (click)="showUserId()"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>